export const TAG = 'BankAccountActionDetails';

export enum PAYMENT_MODE {
  FAST = 'FAST',
  TELEGRAPHIC_TRANSFER = 'TELEGRAPHIC_TRANSFER',
  DBS_MULTI_CURRENCY = 'DBS_MULTI_CURRENCY',
}
